// Mock data for Vizyon Turizm website

export const heroData = {
  title: "Güvenle Taşıyoruz, Geleceğe Ulaştırıyoruz",
  subtitle: "Erzurum'da okul servisi ve personel taşımacılığında güvenli, planlı ve disiplinli hizmet.",
  image: "https://customer-assets.emergentagent.com/job_582365d0-9530-4a31-b3c2-8c5c3b387bb5/artifacts/duf1blrz_WhatsApp%20Image%202026-02-04%20at%2002.18.38.jpeg",
  cta: {
    primary: "Hemen İletişime Geç",
    secondary: "Hizmetlerimizi İncele"
  }
};

export const valueProps = [
  {
    icon: "shield-check",
    title: "Güvenli Sürüş",
    description: "Deneyimli ve belgeli şoförlerimizle güvenli yolculuk"
  },
  {
    icon: "map",
    title: "Planlı Güzergâh",
    description: "Optimize edilmiş rotalarla zamanında hizmet"
  },
  {
    icon: "clock",
    title: "Disiplinli Hizmet",
    description: "Düzenli ve kesintisiz taşımacılık"
  },
  {
    icon: "snowflake",
    title: "Erzurum'a Uygun",
    description: "Kış şartlarına özel donanımlı araçlar"
  }
];

export const services = [
  {
    id: "okul-servisi",
    title: "Okul Servisi Hizmeti",
    shortDesc: "Öğrenci güvenliği öncelikli, disiplinli okul taşımacılığı",
    description: "Çocuklarınızın güvenliğini en üst düzeyde tutarak, her gün düzenli ve zamanında okul taşımacılığı hizmeti sunuyoruz. Deneyimli şoförlerimiz ve düzenli bakımlı araçlarımızla velilerimize tam güven veriyoruz.",
    image: "https://customer-assets.emergentagent.com/job_582365d0-9530-4a31-b3c2-8c5c3b387bb5/artifacts/duf1blrz_WhatsApp%20Image%202026-02-04%20at%2002.18.38.jpeg",
    features: [
      "Deneyimli ve güvenilir şoförler",
      "Güvenlik kemeri zorunluluğu",
      "Düzenli araç bakımı ve kontroller",
      "Planlı güzergâh takibi",
      "Veli iletişim hattı"
    ],
    benefits: [
      {
        icon: "user-check",
        title: "Belgeli Şoförler",
        desc: "Tüm şoförlerimiz SRC belgeli ve deneyimlidir"
      },
      {
        icon: "calendar-check",
        title: "Düzenli Servis",
        desc: "Her gün aynı saatlerde kesintisiz hizmet"
      },
      {
        icon: "shield",
        title: "Güvenlik Önceliği",
        desc: "Tüm güvenlik standartlarına uygun araçlar"
      }
    ]
  },
  {
    id: "ogrenci-tasimaciligi",
    title: "Öğrenci Taşımacılığı",
    shortDesc: "Planlı güzergâhlarla zamanında ve güvenli öğrenci taşıma",
    description: "Okul ve dershane taşımacılığında uzman kadromuzla öğrencilerinizi en güvenli şekilde taşıyoruz. Her güzergâh titizlikle planlanır ve kesintisiz takip edilir.",
    image: "https://customer-assets.emergentagent.com/job_582365d0-9530-4a31-b3c2-8c5c3b387bb5/artifacts/j2tq2k7f_WhatsApp%20Image%202026-02-04%20at%2002.18.38%20%282%29.jpeg",
    features: [
      "Optimize edilmiş güzergâhlar",
      "Zamanında teslimat garantisi",
      "Konforlu ve temiz araçlar",
      "Velilere bilgilendirme sistemi",
      "Acil durum protokolleri"
    ],
    benefits: [
      {
        icon: "route",
        title: "Akıllı Güzergâh",
        desc: "En kısa ve güvenli rotalar"
      },
      {
        icon: "clock-3",
        title: "Zamanında Hizmet",
        desc: "Dakiklik ve disiplin garantisi"
      },
      {
        icon: "phone",
        title: "7/24 İletişim",
        desc: "Her zaman ulaşılabilir destek"
      }
    ]
  },
  {
    id: "personel-tasimaciligi",
    title: "Personel Taşımacılığı",
    shortDesc: "Kurumlara özel esnek ve konforlu personel servis hizmeti",
    description: "Firmalar için özel çözümler sunuyoruz. Personel taşımacılığında esnek saatler, konforlu araçlar ve profesyonel hizmet anlayışıyla çalışıyoruz.",
    image: "https://customer-assets.emergentagent.com/job_582365d0-9530-4a31-b3c2-8c5c3b387bb5/artifacts/yr985g2t_WhatsApp%20Image%202026-02-04%20at%2002.18.38%20%283%29.jpeg",
    features: [
      "Kurumlara özel çözümler",
      "Esnek çalışma saatleri",
      "Geniş araç filosu",
      "Profesyonel şoförler",
      "Düzenli raporlama"
    ],
    benefits: [
      {
        icon: "briefcase",
        title: "Kurumsal Hizmet",
        desc: "İşletmenize özel çözümler"
      },
      {
        icon: "timer",
        title: "Esnek Saatler",
        desc: "Vardiya sistemlerine uygun planlama"
      },
      {
        icon: "users",
        title: "Geniş Kapasite",
        desc: "Farklı sayıda personel için araç seçenekleri"
      }
    ]
  },
  {
    id: "arac-filosu",
    title: "Araç Filosu",
    shortDesc: "Modern ve bakımlı araçlarla güvenli taşımacılık",
    description: "Düzenli bakımı yapılan, kış şartlarına uygun donanımlı modern araç filomuzla her türlü hava koşulunda güvenli hizmet sunuyoruz.",
    image: "https://customer-assets.emergentagent.com/job_582365d0-9530-4a31-b3c2-8c5c3b387bb5/artifacts/xmu82e7u_WhatsApp%20Image%202026-02-04%20at%2002.18.38%20%284%29.jpeg",
    features: [
      "Düzenli periyodik bakımlar",
      "Kış lastiği ve zincir donanımı",
      "Modern güvenlik sistemleri",
      "Temiz ve hijyenik iç mekan",
      "Kasko ve trafik sigortası"
    ],
    benefits: [
      {
        icon: "wrench",
        title: "Düzenli Bakım",
        desc: "Tüm araçlar periyodik bakımlı"
      },
      {
        icon: "snowflake",
        title: "Kış Hazırlığı",
        desc: "Erzurum şartlarına özel donanım"
      },
      {
        icon: "sparkles",
        title: "Temizlik",
        desc: "Her gün dezenfekte edilen araçlar"
      }
    ]
  }
];

export const whyChooseUs = [
  {
    icon: "award",
    title: "Deneyimli ve Belgeli Şoförler",
    description: "Tüm şoförlerimiz SRC belgeli, deneyimli ve sürekli eğitim almaktadır."
  },
  {
    icon: "settings",
    title: "Düzenli Bakım ve Kontroller",
    description: "Araçlarımız düzenli periyodik bakımlardan geçer ve her gün kontrol edilir."
  },
  {
    icon: "map-pin",
    title: "Güvenli ve Planlı Güzergâhlar",
    description: "Her güzergâh titizlikle planlanır ve güvenlik öncelikli olarak belirlenir."
  },
  {
    icon: "mountain-snow",
    title: "Erzurum Şartlarına Uygun",
    description: "Kış şartlarına özel donanımlı araçlarımızla her mevsim güvenli hizmet."
  },
  {
    icon: "clock",
    title: "Disiplinli Servis Anlayışı",
    description: "Zamanında ve düzenli hizmet anlayışıyla kesintisiz taşımacılık."
  },
  {
    icon: "heart-handshake",
    title: "%100 Müşteri Memnuniyeti",
    description: "Velilerimizin ve kurumlarımızın güvenini kazanmış, referans gösterilen firma."
  }
];

export const testimonials = [
  {
    name: "Ayşe Yılmaz",
    role: "Veli",
    school: "Atatürk İlkokulu",
    content: "3 yıldır çocuğum Vizyon Turizm servisleriyle okula gidiyor. Şoförler çok güler yüzlü ve güvenilir. Hiçbir gün gecikmeden zamanında gelip gidiyorlar. Çok memnunuz.",
    rating: 5
  },
  {
    name: "Mehmet Demir",
    role: "Veli",
    school: "Cumhuriyet Ortaokulu",
    content: "Kış şartlarında bile hiç aksama olmadan hizmet veriyorlar. Araçlar temiz ve bakımlı. Çocuğumu gönül rahatlığıyla emanet ediyorum.",
    rating: 5
  },
  {
    name: "Fatma Öztürk",
    role: "İnsan Kaynakları Müdürü",
    company: "ABC Tekstil",
    content: "Personel taşımacılığında çok profesyoneller. Vardiya saatlerimize göre esnek çalışıyorlar ve personelimiz çok memnun. Kesinlikle tavsiye ederim.",
    rating: 5
  },
  {
    name: "Ali Kaya",
    role: "Veli",
    school: "Gazi İlkokulu",
    content: "Şoförler deneyimli ve çocuklara karşı çok sabırlılar. Servis içi temiz ve düzenli. Her veliye tavsiye ederim.",
    rating: 5
  },
  {
    name: "Zeynep Şahin",
    role: "İşletme Müdürü",
    company: "XYZ Gıda",
    content: "6 aydır personel taşımacılığı hizmeti alıyoruz. Düzenli, zamanında ve sorunsuz bir hizmet. Teşekkür ederiz.",
    rating: 5
  },
  {
    name: "Hasan Çelik",
    role: "Veli",
    school: "İstiklal İlkokulu",
    content: "2 çocuğum da Vizyon Turizm servisleriyle okula gidiyor. Güvenli ve disiplinli hizmet. Veliler olarak çok rahatız.",
    rating: 5
  }
];

export const faqData = [
  {
    question: "Şoförleriniz belgeli mi?",
    answer: "Evet, tüm şoförlerimiz SRC (Sürücü Yeterlilik Belgesi) sahibidir ve düzenli eğitimler almaktadır. Ayrıca her şoför için geçmiş kontrolleri yapılmaktadır."
  },
  {
    question: "Araçlarınız ne sıklıkla bakıma alınıyor?",
    answer: "Araçlarımız her ay periyodik bakımdan geçer. Bunun yanında her gün araç kontrolleri yapılır ve kış şartlarına özel ekstra kontroller uygulanır."
  },
  {
    question: "Kış şartlarında hizmet aksıyor mu?",
    answer: "Hayır, araçlarımız Erzurum'un zorlu kış şartlarına özel donanımlıdır. Kış lastiği, zincir ve diğer gerekli ekipmanlarla donatılmıştır. Her türlü hava koşulunda güvenli hizmet veriyoruz."
  },
  {
    question: "Serviste güvenlik önlemleri nelerdir?",
    answer: "Tüm öğrenciler için emniyet kemeri zorunluluğu, hız limitlerinin takibi, güvenli sürüş eğitimi almış şoförler ve acil durum protokolleri uyguluyoruz."
  },
  {
    question: "Servis güzergâhları nasıl belirleniyor?",
    answer: "Güzergâhlar ailelerin ve kurumların taleplerine göre optimize edilir. En güvenli ve en kısa rotalar titizlikle planlanır ve düzenli olarak takip edilir."
  },
  {
    question: "Servis saatleri değiştirilebilir mi?",
    answer: "Evet, özellikle personel taşımacılığında esnek saatlerle çalışıyoruz. Vardiya sistemlerine göre özel planlamalar yapabiliriz."
  },
  {
    question: "Araçlarınızda kaç kişi taşınıyor?",
    answer: "Araç kapasitelerimiz ihtiyaca göre değişmektedir. 14, 20 ve 30 kişilik araç seçeneklerimiz mevcuttur. Her araç yasal yolcu kapasitesine uygun olarak çalıştırılır."
  },
  {
    question: "Acil durumlarda nasıl iletişim kurabilirim?",
    answer: "7/24 ulaşılabilir telefon hattımız ve WhatsApp destek hattımız bulunmaktadır. Acil durumlarda anında müdahale edilir ve aileler bilgilendirilir."
  }
];

export const contactInfo = {
  phone: "0 (534) 041 48 48",
  phone3: "0 (541) 149 25 25",
  whatsapp: "0 (541) 149 25 25",
  whatsappFormatted: "+905411492525",
  email: "info@vizyonturizm.com",
  address: "Yakutiye / Erzurum, Türkiye",
  mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d48624.59932846194!2d41.25280983499053!3d39.90387839089118!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406e36e6c5d6c1f5%3A0x3f8e0e0f8e8e0e0e!2sErzurum%2C%20Turkey!5e0!3m2!1sen!2s!4v1234567890123!5m2!1sen!2s"
};

export const aboutData = {
  title: "Hakkımızda",
  subtitle: "Güven, Disiplin ve Sorumluluk",
  story: "Vizyon Turizm olarak Erzurum'da yıllardır okul servisi ve personel taşımacılığı alanında hizmet veriyoruz. Misyonumuz, çocuklarımızın ve çalışanların güvenli, konforlu ve zamanında taşınmasını sağlamaktır.",
  mission: "Erzurum'un zorlu iklim şartlarında bile kesintisiz, güvenli ve kaliteli taşımacılık hizmeti sunarak ailelerin ve kurumların güvenini kazanmak.",
  vision: "Bölgenin en güvenilir ve tercih edilen taşımacılık firması olmak, sürekli gelişen hizmet anlayışımızla standartları yükseltmek.",
  values: [
    {
      icon: "shield-check",
      title: "Güvenlik",
      desc: "Her şeyden önce güvenlik"
    },
    {
      icon: "clock",
      title: "Disiplin",
      desc: "Zamanında ve düzenli hizmet"
    },
    {
      icon: "heart",
      title: "Sorumluluk",
      desc: "Emanete hakkıyla sahip çıkma"
    },
    {
      icon: "handshake",
      title: "Güven",
      desc: "Ailelerin tam güveni"
    }
  ],
  image: "https://customer-assets.emergentagent.com/job_582365d0-9530-4a31-b3c2-8c5c3b387bb5/artifacts/97s6zokf_WhatsApp%20Image%202026-02-04%20at%2002.18.38%20%281%29.jpeg"
};
